export const isAuthenticated = (state) => {
    return Boolean(state.auth && state.auth.token);
};
